export default __webpack_public_path__ + "alberta-customer-number.0bac494b24185f23909b.svg";